/**
 * Browser and client metadata utilities
 */

import { i18n } from '@plerionhq/design-system/i18n';

import { isExtension } from './tokenUtils';

/**
 * Returns common metadata about the client environment
 */
export const getClientMetadata = () => {
  // Get browser type
  const userAgent = navigator.userAgent;
  let browser = 'unknown';

  if (userAgent.indexOf('Chrome') > -1) {
    browser = 'Chrome';
  } else if (userAgent.indexOf('Firefox') > -1) {
    browser = 'Firefox';
  } else if (userAgent.indexOf('Safari') > -1) {
    browser = 'Safari';
  } else if (
    userAgent.indexOf('MSIE') > -1 ||
    userAgent.indexOf('Trident') > -1
  ) {
    browser = 'Internet Explorer';
  } else if (userAgent.indexOf('Edge') > -1) {
    browser = 'Edge';
  }

  return {
    workspaceType: isExtension ? 'browser-extension' : 'plerion-platform',
    referer: window.location.href,
    browser,
    userAgent,
    // Pleri replies in the language the app is showing.
    language: i18n.resolvedLanguage || i18n.language,
  };
};

export const getBrowserType = (): 'chrome' | 'firefox' | 'other' => {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('Firefox') > -1) {
    return 'firefox';
  } else if (userAgent.indexOf('Chrome') > -1) {
    return 'chrome';
  }
  return 'other';
};
